import { Box, Fab } from "@mui/material";
import React from "react";
import { useFinishContext } from "../context";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";

export const FinishTopBanner = ({ finishOperationsParam, buttonType }) => {
  const { setCurrentOperationPage } = useFinishContext();
  return (
    <>
      <Box component="section" flex={1} textAlign={"right"}>
        {buttonType === "back" ? (
          <Fab
            color="primary"
            size="small"
            aria-label="Back"
            onClick={() => setCurrentOperationPage(finishOperationsParam)}
          >
            <ArrowBackIcon />
          </Fab>
        ) : (
          <Fab
            color="primary"
            size="small"
            aria-label="Add"
            onClick={() => setCurrentOperationPage(finishOperationsParam)}
          >
            <AddIcon />
          </Fab>
        )}
      </Box>
      <ToolbarThinWrapper />
    </>
  );
};
